import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

const ProductsReportsSection = "/reports/bi/products";

export const ProductsReportsListPath = ProductsReportsSection;

export enum ProductsReportsListUrlFiltersEnum {
  query = "query",
  orderDateFrom = "orderDateFrom",
  orderDateTo = "orderDateTo",
  tenantType = "tenantType"
}

export enum ProductsReportsListUrlFiltersWithMultipleValues {
  mall = "mall",
  brand = "brand"
}

export type ProductsReportsListUrlDialog = "download" | TabActionDialog;
export type ProductsReportsListUrlFilters = Filters<
  ProductsReportsListUrlFiltersEnum
> &
  FiltersWithMultipleValues<ProductsReportsListUrlFiltersWithMultipleValues>;

export type ProductsReportsUrlQueryParams = ActiveTab &
  ProductsReportsListUrlFilters &
  BulkAction &
  Dialog<ProductsReportsListUrlDialog> &
  Pagination &
  SingleAction;

export const ProductsReportsListUrl = (
  params?: ProductsReportsUrlQueryParams
) => ProductsReportsListPath + "?" + stringifyQs(params);
